import { useCallback } from 'react';
import { sessionStorage } from '@fiverr-private/futile';

export enum SessionDataKeys {
    PAGE_DATA = 'pagedata',
    SCROLL_POSITION = 'scrollPosition',
}

export const useSessionStorage = () => {
    const popStorageData = useCallback((key: SessionDataKeys) => {
        const pageData = sessionStorage.get(key);
        sessionStorage.set(key, null);
        return pageData ? JSON.parse(pageData) : null;
    }, []);

    const cacheStorageData = useCallback((key: SessionDataKeys, data: any) => {
        sessionStorage.set(key, JSON.stringify(data));
    }, []);

    return {
        popStorageData,
        cacheStorageData,
    };
};
